import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';
import { CommonModule } from '@angular/common';
import { Menu } from 'primeng/menu';
import { FormsModule } from '@angular/forms';
import { OauthService, UserInfo } from '../../services/oauth.service';
import { PrimeIcons } from 'primeng/api';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-prime-menu',
  standalone: true,
  imports: [
    CommonModule,
    MenuModule,
    FormsModule,
  ],
  templateUrl: './prime-menu.component.html',
  styleUrls: ['./prime-menu.component.css']
})
export class PrimeMenuComponent implements OnInit, AfterViewInit {
  @ViewChild('menu') menu!: Menu;
  @ViewChild('menuButton') menuButton!: ElementRef;
  private routerSubscription: Subscription;
  menuItems: MenuItem[] = [];

  page: string = '';

  userInfo: UserInfo | null = null;
  isSigningOut = false;

  constructor(
    private router: Router,
    private auth: OauthService,
  ) {
    this.routerSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(async (event: NavigationEnd) => {
        const page = event.url.split('/')[1];
        this.page = page;
        // await this.manageSidebar(page);
      });
   }

  ngOnInit() {
    // Get user info
    this.auth.getUser();

    // Add error handling to subscription
    this.auth.userSignIn$.subscribe({
      next: (info) => {
        // console.log('User sign-in event received:', info);
        this.userInfo = info;
        this.updateMenuItems();
      },
      error: (err) => console.error('Error in userSignIn$ subscription:', err)
    });

    // Initialize menu items immediately
    this.updateMenuItems();
  }

  updateMenuItems() {
    if (this.userInfo) {
      this.menuItems = [
        {
          label: 'Workspace',
          icon: 'pi pi-fw pi-briefcase',
          command: () => this.router.navigate(['/workspace']),
          template: 'regularItem'
        },
        {
          label: 'USDM',
          icon: 'pi pi-curly-brackets',
          command: () => this.router.navigate(['/usdm']),
          template: 'regularItem'
        },
        {
          label: 'SDTM',
          icon: 'pi pi-table',
          command: () => this.router.navigate(['/sdtm']),
          template: 'regularItem'
        },
        // {
        //   label: 'SAP AI',
        //   icon: 'pi pi-file-edit',
        //   command: () => this.router.navigate(['/sap']),
        //   template: 'regularItem'
        // },
        // {
        //   label: 'Synthetic Data',
        //   icon: 'pi pi-sparkles',
        //   command: () => this.router.navigate(['/synthetic']),
        //   template: 'regularItem'
        // },
        // {
        //   label: 'TFL AI',
        //   icon: 'pi pi-chart-bar',
        //   command: () => this.router.navigate(['/tfl']),
        //   template: 'regularItem'
        // },
        {
          label: 'Docs',
          icon: 'pi pi-book',
          command: () => window.open('/docs', '_blank'),
          template: 'regularItem'
        },
        {separator: true},
        {
          label: 'Your Profile',
          icon: PrimeIcons.USER,
          command: () => this.router.navigate(['/profile']),
          template: 'regularItem'
        },
        {
          label: 'Settings',
          icon: 'pi pi-cog',
          command: () => this.router.navigate(['/settings']),
          template: 'regularItem'
        },
        { separator: true },
        {
          label: this.isSigningOut ? 'Signing out...' : 'Sign Out',
          icon: 'pi pi-power-off',
          disabled: this.isSigningOut,
          command: () => this.signOut(),
          styleClass: 'signout-item',
          template: 'regularItem'
        }
      ];
    } else {
      this.menuItems = [
        {
          label: 'Dashboard',
          icon: 'pi pi-home',
          command: () => this.router.navigate(['/']),
          template: 'regularItem'
        }
      ];
    }

    // Force change detection and ensure menu is updated
    setTimeout(() => {
      if (this.menu) {
        this.menu.cd.markForCheck();
      }
    }, 0);
  }

  ngAfterViewInit() {
    // Add event listeners for menu show/hide
    if (this.menu) {
      this.menu.onShow.subscribe(() => {
        if (this.menuButton && this.menuButton.nativeElement) {
          this.menuButton.nativeElement.classList.add('menu-open');
        }
      });

      this.menu.onHide.subscribe(() => {
        if (this.menuButton && this.menuButton.nativeElement) {
          this.menuButton.nativeElement.classList.remove('menu-open');
        }
      });
    }

    // Add a document click listener to handle clicks outside
    document.addEventListener('click', (event) => {
      // If menu exists and is visible, and click is outside menu and button
      if (this.menu && this.menu.visible &&
        this.menuButton && !this.menuButton.nativeElement.contains(event.target) &&
        !this.menu.containerViewChild?.nativeElement.contains(event.target)) {
        // Remove the menu-open class
        this.menuButton.nativeElement.classList.remove('menu-open');
      }
    });

    setTimeout(() => {
      if (!this.menu) {
        console.error('Menu component not found after initialization');
      }
    }, 500);
  }

  toggleMenu(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    // console.log('Toggle menu called, menu exists:', !!this.menu);

    if (this.menu) {
      // Toggle the menu
      this.menu.toggle(event);

      // Toggle the menu-open class on the button
      if (this.menuButton && this.menuButton.nativeElement) {
        if (this.menu.visible) {
          this.menuButton.nativeElement.classList.add('menu-open');
        } else {
          this.menuButton.nativeElement.classList.remove('menu-open');
        }
      }
    } else {
      console.error('Menu component not found');
    }
  }

  async signOut() {
    this.isSigningOut = true;
    this.updateMenuItems();

    this.auth.signOut().then((success) => {
      if (success) {
        window.location.href = '/';
      } else {
        this.isSigningOut = false;
        this.updateMenuItems();
      }
    });
    sessionStorage.clear();
    this.userInfo = null;
  }
}
